import cn from 'classnames'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import config from '../../config.json'
import StatsElement from '../collection/StatsElement'
import { get } from '../helpers/Api'
import LoadingIndicator from '../loadingindicator/LoadingIndicator'
import TemplatesTableElement from './TemplatesTableElement'

const TemplatesTable = (props) => {
    const { title, className } = props
    const [topTemplates, setTopTemplates] = useState(null)
    const [isLoading, setIsLoading] = useState(true)
    const { t } = useTranslation('common')

    const getTopTemplates = async () => {
        return await get(
            `top-templates/1?limit=${config.landingpage.elementcount}`,
            'v1',
        )
    }

    const parseTopTemplates = (res) => {
        setTopTemplates(res)
        setIsLoading(false)
    }

    useEffect(() => {
        getTopTemplates().then((res) => parseTopTemplates(res))
    }, [])

    const textClass = cn('px-2 py-4')

    return (
        <StatsElement title={title} className={className}>
            <div
                className={cn('w-full h-full overflow-x-auto')}
                id={'TopTemplates'}
            >
                {isLoading ? (
                    <LoadingIndicator />
                ) : (
                    <table
                        className={cn(
                            'w-full my-auto text-xs lg:text-sm font-normal',
                            'overflow-hidden',
                            'whitespace-nowrap',
                        )}
                    >
                        <thead>
                            <tr
                                className={cn(
                                    'font-bold md:font-semibold text-main',
                                )}
                            >
                                <td className={cn(textClass, 'text-left')}></td>
                                <td className={cn('text-left px-4 py-2')}></td>
                                <td className={cn(textClass, 'text-left')}>
                                    {t('landing.name_col')}
                                </td>
                                <td className={cn(textClass, 'text-center')}>
                                    {t('landing.cheapest_col')}
                                </td>
                                <td className={cn(textClass, 'text-center')}>
                                    {t('landing.volume_col')}
                                </td>
                                <td className={cn(textClass, 'text-right')}>
                                    {t('landing.change_col')}
                                </td>
                                <td className={cn(textClass, 'text-right')}>
                                    {t('landing.sales_col')}
                                </td>
                            </tr>
                        </thead>
                        <tbody className="overflow-y-auto">
                            {topTemplates &&
                                topTemplates.map((topTemplate, index) => (
                                    <TemplatesTableElement
                                        key={'TemplatesTableElement-' + index}
                                        topTemplate={topTemplate}
                                        index={index}
                                    />
                                ))}
                        </tbody>
                    </table>
                )}
            </div>
        </StatsElement>
    )
}

export default TemplatesTable
